import styled from "styled-components";
import {grey} from "../../../libs/uiKit/globalStyledComponents";

export const StyledHeaderWrapper = styled.div`
	padding: 4rem;
	width: calc(100% - 8rem);
	@media screen and (max-width: 767px) {
		padding: 1.5rem;
		width: calc(100% - 3rem);
	}
`;

export const StyledInputWithApplyButton = styled.div<{ isGreen: boolean }>`
    margin-bottom: 10px;
    input {
        color: ${props => (props.isGreen ? 'green' : 'black')};
    }
`;

export const StyledSmallApplyButton = styled.div`
    button {
        height: 4rem;
        width: 11rem;
    }
`;

export const StyledBigPremiumHeader = styled.h1`
    font-family: "Futura PT Demi";
    font-size: 2rem;
    line-height: 5rem;
    font-weight: 600;
`;

export const StyledCrossedPremiumHeader = styled.span`
    font-family: "Futura PT Demi";
    font-size: 1.5rem;
    line-height: 5rem;
    font-weight: 400;
    text-decoration: line-through;
    opacity: 0.5;
`;